module.exports = __webpack_public_path__ + "media/kurmaTutorial.ec53bf09.mp4";